import { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../components/Logo';
import NavLink from '../../components/NavLink';

export default function About() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);


  return (
    <div className="min-h-screen bg-white  transition-colors" style={{ fontFamily: 'Prompt, sans-serif' }}>
      {/* Navigation */}
      <nav className="absolute top-0 left-0 right-0 z-50 bg-transparent">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-start py-4">
            <div className="flex items-start">
              <Link to="/">
                <Logo size="md" className="hover:scale-105 transition-transform cursor-pointer" />
              </Link>
            </div>
            
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8 pt-4">
                <NavLink to="/">HOME</NavLink>
                <NavLink to="/about">ABOUT</NavLink>
                <NavLink to="/services">SERVICES</NavLink>
                <NavLink to="/products">PROJECTS</NavLink>
                <NavLink to="/contact">CONTACT</NavLink>
              </div>
            </div>

            <div className="hidden md:flex items-center space-x-4 pt-4">
              <a href="/contact" className="bg-zbm-secondary hover:bg-zbm-secondary-dark text-white px-6 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer drop-shadow-lg">
                Get a Quote
              </a>
            </div>

            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-zbm-primary hover:text-zbm-primary-dark cursor-pointer drop-shadow-lg"
              >
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white/95 /95 backdrop-blur-sm border-t border-gray-100 ">
              <NavLink to="/" mobile={true}>HOME</NavLink>
              <NavLink to="/about" mobile={true}>ABOUT</NavLink>
              <NavLink to="/services" mobile={true}>SERVICES</NavLink>
              <NavLink to="/products" mobile={true}>PROJECTS</NavLink>
              <NavLink to="/contact" mobile={true}>CONTACT</NavLink>
              <a href="/contact" className="bg-zbm-secondary hover:bg-zbm-secondary-dark text-white px-6 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer w-full mt-2">
                Get a Quote
              </a>
            </div>
          </div>
        )}
      </nav>

      {/* Header Separator Line */}
      <div className="w-full h-px bg-gray-300 mt-32"></div>

      {/* Hero Section */}
      <section className="relative pt-20 pb-20" style={{ backgroundColor: '#F7F7F7' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h1 className="text-4xl lg:text-6xl font-extrabold text-gray-900  mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>
                About
                <span className="text-zbm-primary block">ZBM Projects</span>
              </h1>
              <p className="text-xl text-gray-600  mb-8 leading-relaxed font-normal">
                A 100% Black-owned private company specializing in prefabricated structures, civil and building construction projects. Led by Ms. Z. Dlamini, we deliver high-quality infrastructure solutions across South Africa.
              </p>
              <div className="grid grid-cols-2 gap-8">
                <div>
                  <h3 className="text-3xl font-bold text-zbm-primary mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>10+</h3>
                  <p className="text-gray-600  font-normal">Years Combined Experience</p>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-zbm-secondary mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>100%</h3>
                  <p className="text-gray-600  font-normal">Black-Owned</p>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-zbm-primary mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>20+</h3>
                  <p className="text-gray-600  font-normal">Projects Completed</p>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-zbm-secondary mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>ECSA</h3>
                  <p className="text-gray-600  font-normal">Registered Professionals</p>
                </div>
              </div>
            </div>
            
            <div>
              <img 
                src="/projects/zbm-projects (8).jpeg"
                alt="ZBM Projects Construction Team"
                className="rounded-2xl shadow-2xl object-cover w-full h-96 lg:h-[500px]"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-white ">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900  mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>Our Story</h2>
            <p className="text-lg text-gray-600  leading-relaxed mb-8 font-normal">
              ZBM Projects is a 100% Black-owned private company specializing in prefabricated structures, as well as civil and building construction projects. Since our inception, we have been dedicated to delivering high-quality infrastructure solutions that meet the needs of both the public and private sectors.
            </p>
            <p className="text-lg text-gray-600  leading-relaxed mb-8 font-normal">
              The company is led by Ms. Z. Dlamini, a young and ambitious entrepreneur whose journey in the construction industry began as a clerk at a construction firm. Her passion for the built environment and commitment to creating impactful projects inspired her to establish ZBM Projects, with the vision of contributing meaningfully to South Africa's infrastructure development.
            </p>
            <p className="text-lg text-gray-600  leading-relaxed font-normal">
              Supporting our leadership team are experienced professionals including Mr. Z. Mabaso, a Professional Engineering Technician registered with ECSA, who brings over 10 years of management-level experience; Mr. R. Msezane, our Foreman with more than 14 years of hands-on construction experience; and other qualified engineers and project managers who ensure every project is executed with precision, quality, and efficiency.
            </p>
          </div>
        </div>
      </section>

      {/* Our Team Section */}
      <section id="team" className="py-20 bg-gradient-to-br from-zbm-light to-zbm-light dark:from-gray-800 dark:to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Our Expert Team</h2>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto font-normal">
              Meet the professionals driving excellence and innovation in every project we undertake.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white  p-8 rounded-2xl shadow-lg">
              <div className="w-16 h-16 bg-zbm-primary rounded-full flex items-center justify-center mb-6">
                <i className="ri-user-star-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Ms. Z. Dlamini</h3>
              <p className="text-zbm-primary font-semibold mb-4">Director</p>
              <p className="text-gray-600  font-normal">
                Founder and Director of ZBM Projects. A passionate and driven entrepreneur who began her career as a clerk in construction. Her leadership and strategic vision position ZBM Projects as a growing player in the civil engineering and construction sector.
              </p>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg">
              <div className="w-16 h-16 bg-zbm-secondary rounded-full flex items-center justify-center mb-6">
                <i className="ri-shield-user-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Mr. Z. Mabaso</h3>
              <p className="text-zbm-secondary font-semibold mb-4">Contracts Manager | PR TECH | B-Tech Civil Eng.</p>
              <p className="text-gray-600  font-normal">
                Over 10 years of experience managing construction contracts. Registered with ECSA as a Professional Engineering Technician. Key responsibilities include contract management, bid analysis, stakeholder liaison, and ensuring adherence to contractual obligations.
              </p>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg">
              <div className="w-16 h-16 bg-zbm-primary rounded-full flex items-center justify-center mb-6">
                <i className="ri-tools-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Mr. R. Msezane</h3>
              <p className="text-zbm-primary font-semibold mb-4">Foreman</p>
              <p className="text-gray-600  font-normal">
                More than 14 years of hands-on experience in construction and building. Supervises daily on-site activities, coordinates site teams, and ensures work meets the highest standards of quality, safety, and efficiency.
              </p>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg">
              <div className="w-16 h-16 bg-zbm-secondary rounded-full flex items-center justify-center mb-6">
                <i className="ri-draft-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Mr. Malinga Vilakazi</h3>
              <p className="text-zbm-secondary font-semibold mb-4">Contract Engineer | BSC Hon. (Structural)</p>
              <p className="text-gray-600  font-normal">
                Over 15 years of experience in structural design, drafting, contract negotiation, and full lifecycle contract management. Ensures all projects adhere to technical specifications, legal frameworks, and industry standards.
              </p>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg">
              <div className="w-16 h-16 bg-zbm-primary rounded-full flex items-center justify-center mb-6">
                <i className="ri-briefcase-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Mr. Sabelo Zulu</h3>
              <p className="text-zbm-primary font-semibold mb-4">Project Manager | B-Tech Civil Eng.</p>
              <p className="text-gray-600  font-normal">
                Manages and oversees construction projects ensuring objectives, legal requirements, and budgets are met. Handles bid analysis, contract management, construction drawings, and serves as liaison between all stakeholders.
              </p>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg">
              <div className="w-16 h-16 bg-zbm-secondary rounded-full flex items-center justify-center mb-6">
                <i className="ri-file-list-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Ms. Anele Zwane</h3>
              <p className="text-zbm-secondary font-semibold mb-4">Office Administrator | Hon. B.A | Advance Dip. (Public Management)</p>
              <p className="text-gray-600  font-normal">
                Provides administrative support including project documentation management, scheduling, invoicing, and coordinating communication between construction teams, subcontractors, and clients.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-zbm-light dark:from-gray-800 dark:to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Our Core Values</h2>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto font-normal">
              These principles guide our approach to every project and define our commitment to excellence.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white  p-8 rounded-2xl shadow-lg text-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: '#1E3A8A' }}>
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Quality & Safety</h3>
              <p className="text-gray-600  font-normal">
                We design, build, and deliver infrastructure projects that meet the highest standards of quality, safety, and sustainability in every aspect of construction.
              </p>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg text-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: '#EA580C' }}>
                <i className="ri-customer-service-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Client Excellence</h3>
              <p className="text-gray-600  font-normal">
                We provide professional, cost-effective, and reliable construction services that consistently exceed client expectations through dedicated project delivery.
              </p>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg text-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: '#1E3A8A' }}>
                <i className="ri-team-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Partnership & Trust</h3>
              <p className="text-gray-600  font-normal">
                We foster long-term partnerships with public and private sector stakeholders based on trust, integrity, and consistent performance.
              </p>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg text-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: '#EA580C' }}>
                <i className="ri-user-heart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Community Development</h3>
              <p className="text-gray-600  font-normal">
                We support skills development and create employment opportunities within the communities where we operate, contributing to socio-economic growth.
              </p>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg text-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: '#1E3A8A' }}>
                <i className="ri-lightbulb-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Innovation & Technology</h3>
              <p className="text-gray-600  font-normal">
                We embrace innovation, technology, and industry best practices to continuously improve project outcomes and stay ahead of industry standards.
              </p>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg text-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: '#EA580C' }}>
                <i className="ri-plant-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Sustainable Development</h3>
              <p className="text-gray-600  font-normal">
                We contribute actively to South Africa's infrastructure growth through sustainable engineering solutions that drive economic development.
              </p>
            </div>
          </div>
        </div>
      </section>



      {/* Partners/Clients Section */}
      <section className="py-20 bg-white ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-4">
              <span className="text-3xl mr-3">🤝</span>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 " style={{ fontFamily: 'Prompt, sans-serif' }}>Our Trusted Partners</h2>
            </div>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto font-normal">
              Building strong relationships with leading organizations across South Africa
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
            {[1, 2, 3, 4, 5, 6].map((num) => (
              <div key={num} className="flex items-center justify-center p-6 bg-gray-50  rounded-lg hover:shadow-lg transition-shadow">
                <img 
                  src={`/partners/zbm-partners (${num}).jpeg`}
                  alt={`Partner ${num}`}
                  className="max-h-20 w-auto object-contain grayscale hover:grayscale-0 transition-all"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20" style={{ background: 'linear-gradient(to right, #1E3A8A, #EA580C)' }}>
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>
            Ready to Build With Us?
          </h2>
          <p className="text-xl text-white mb-8 leading-relaxed font-normal" style={{ opacity: 0.95 }}>
            Let's bring your infrastructure vision to life. We'd love to discuss your construction project and deliver excellence together.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/contact" className="bg-white text-zbm-primary hover:bg-gray-50 px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer" style={{ fontFamily: 'Prompt, sans-serif' }}>
              Get a Quote
            </a>
            <a href="/products" className="border-2 border-white text-white hover:bg-white hover:text-zbm-primary px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer" style={{ fontFamily: 'Prompt, sans-serif' }}>
              View Our Projects
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-2">
              <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>
                ZBM Projects
              </h3>
              <p className="text-gray-300 mb-6 max-w-md font-normal">
                A 100% Black-owned private company specializing in prefabricated structures, civil and building construction projects. Delivering high-quality infrastructure solutions across South Africa.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="w-10 h-10 bg-zbm-primary hover:bg-zbm-primary-dark rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-zbm-secondary hover:bg-zbm-secondary-dark rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-whatsapp-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Services</h4>
              <ul className="space-y-2 text-gray-300 font-normal">
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Project Management</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Building Construction</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Civil Engineering</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Prefabricated Structures</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Water Infrastructure</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Company</h4>
              <ul className="space-y-2 text-gray-300 font-normal">
                <li><Link to="/" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/about" className="hover:text-zbm-primary-light transition-colors cursor-pointer">About Us</Link></li>
                <li><Link to="/about#team" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Our Team</Link></li>
                <li><Link to="/products" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Projects</Link></li>
                <li><Link to="/contact" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Contact Us</Link></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm font-normal">
              © 2025 ZBM Projects. All Rights Reserved. Reg: 2016/321746/07
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
